import React from "react";
import Select from "react-select";
import { styled } from "@mui/material/styles";

const StyledSelect = styled(Select)(
  ({ theme, Height = "", BorderRadius = true }) => ({
    "& .css-13cymwt-control , & .css-t3ipsp-control": {
      height: Height ? `${Height}px` : "54px",
      width: "100%",
      border: "2px solid #E8E8E8",
      color: "rgba(11, 11, 11, 0.5)",
      borderRadius: BorderRadius ? "0px" : "10px",
      fontSize: "16px",
      lineHeight: "22px",
      color: "rgba(11, 11, 11, 0.5)",
      textTransform: "capitalize",
      fontFamily: theme.typography.fontFamily,
    },
    "& .css-1u9des2-indicatorSeparator": {
      display: "none",
    },
    "& .css-1s1upiv-control , .css-1s79at0-control": {
      height: Height ? `${Height}px` : "54px",
      borderRadius: !BorderRadius ? "0px" : "10px",
    },
  })
);

const customStyles = {
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: state.isDisabled ? "none" : "none",
  }),
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? "1px solid #E8E8E8" : "1px solid #E8E8E8",
    color: "rgba(11, 11, 11, 0.5)",
    borderRadius: "10px",
    boxShadow: "none",
    height: "54px",
    paddingTop: "0px",
    fontSize: "14px",
    fontWeight: 400,
    padding: "0 10px",
    fontFamily: "Open Sans, sans-serif",
    marginBottom: "20px",
    "&:hover": {
      border: "1px solid #0B0B0B",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#F4F4F4",
    boxShadow: "none",
    borderRadius: "5px",
    marginTop: "2px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#F4F4F4" : "#F4F4F4",
    color: state.isSelected ? "#0B0B0B" : "#000",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#E3E3E3",
      color: "#0B0B0B",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "gray",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
  }),
};

const SelectDropDown = ({
  selectedOption,
  options,
  handleChange,
  placeholder = "",
  Height = "",
  BorderRadius,
}) => {
  return (
    <>
      <StyledSelect
        onChange={handleChange}
        options={options}
        value={selectedOption}
        placeholder={placeholder ? placeholder : "Select customers"}
        noOptionsMessage={() => (
          <span style={{ color: "#fff" }}>No data found</span>
        )}
        styles={customStyles}
        Height={Height}
        BorderRadius={BorderRadius}
      />
    </>
  );
};

export default SelectDropDown;
